module.exports = "/_next/static/images/AIAndML-sm-36733af5689a69fd3231dd112648ce04.png";